import { http, requestBlob } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { AccountsApi } from './accounts';

// Paths mirror subsystems/commerce/facade/adapters/admin-api/src/admin/parties.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const accountsHttp: AccountsApi = {
  listCustomers: (query, opts) => http.get('api', '/customers', { query: { ...query }, ...rd(opts) }),
  getCustomerOverview: (id, opts) => http.get('api', `/customers/${seg(id)}/overview`, rd(opts)),
  getCustomerBilling: (id, opts) => http.get('api', `/customers/${seg(id)}/billing`, rd(opts)),
  getCustomerUser: (customerId, userId, opts) => http.get('api', `/customers/${seg(customerId)}/users/${seg(userId)}`, rd(opts)),
  listSubjects: (query, opts) => http.get('api', '/subjects', { query: { ...query }, ...rd(opts) }),
  createCustomer: (body, opts) => http.post('api', '/customers', body, wr(opts)),
  setPrimarySubject: (id, body, opts) => http.put('api', `/customers/${seg(id)}/primary-subject`, body, wr(opts)),
  listCustomerTiers: (opts) => http.get('api', '/customers/tiers', rd(opts)),
  findCustomerDuplicates: (query, opts) => http.get('api', '/customers/duplicates', { query: { ...query }, ...rd(opts) }),
  getCustomerAccount: (id, opts) => http.get('api', `/customers/${seg(id)}`, rd(opts)),
  updateCustomer: (id, body, opts) => http.put('api', `/customers/${seg(id)}`, body, wr(opts)),
  addCustomerUser: (id, body, opts) => http.post('api', `/customers/${seg(id)}/users`, body, wr(opts)),
  adjustCustomerWallet: (id, body, opts) => http.post('api', `/customers/${seg(id)}/wallet/adjustments`, body, wr(opts)),
  // routes/subject_write.rs
  getSubjectProfile: (id, opts) => http.get('api', `/subjects/${seg(id)}/profile`, rd(opts)),
  getSubjectRegistryReadiness: (id, opts) => http.get('api', `/subjects/${seg(id)}/registry-readiness`, rd(opts)),
  createSubject: (body, opts) => http.post('api', '/subjects', body, wr(opts)),
  newSubjectVersion: (id, body, opts) => http.post('api', `/subjects/${seg(id)}/versions`, body, wr(opts)),
  listDossiers: (query, opts) => http.get('api', '/dossiers', { query: { ...query }, ...rd(opts) }),
  getDossier: (id, opts) => http.get('api', `/dossiers/${seg(id)}`, rd(opts)),
  listDocuments: (query, opts) => http.get('api', '/documents', { query: { ...query }, ...rd(opts) }),
  getDocument: (id, opts) => http.get('api', `/documents/${seg(id)}`, rd(opts)),
  getDocumentContent: (id, version, q, opts) =>
    requestBlob('api', `/documents/${seg(id)}/versions/${seg(version)}/content`, { reason: q.reason, download: q.download ? 1 : undefined }, opts?.signal),
};
